<h2 mat-dialog-title>{{ "deviceConnectDialogComponent.title" | translate }}</h2>
<div>
  <div style="margin-bottom: 10px">
    <span>{{ "deviceConnectDialogComponent.serialNumber" | translate }}</span>
  </div>
  <div style="margin-bottom: 16px">
    <mat-form-field style="width: 100%">
      <mat-label>{{ "deviceConnectDialogComponent.pinCode" | translate }}</mat-label>
      <input matInput maxlength="100" [formControl]="pinCodeForm" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <div fxFlex fxLayout="row" fxLayoutAlign="center">
      <button mat-button color="primary" [mat-dialog-close]="true">
        {{ "deviceConnectDialogComponent.cancel" | translate }}
      </button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="connectDevice()">
        {{ "deviceConnectDialogComponent.register" | translate }}
      </button>
    </div>
  </div>
</div>
